export const tickerText = {
  text: `New Album • Sentimental Fool• Out Now`,
  link: 'https://daptone.ffm.to/sentimentalfool.OWE',
}
